import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import MusicLibrary from '@/views/MusicLibrary'
import Radios from '@/views/Radios'
import Radio from '@/views/Radio'
import Players from '@/views/Players'
import MarketingCampaigns from '@/views/MarketingCampaigns'
import Clients from '@/views/Clients'
import Users from '@/views/Users'
import Playlists from '@/views/Playlists'
import RadioSchedule from '@/components/radio/RadioSchedule'
import Playlist from '@/views/Playlist'
import Player from '@/views/Player'
import PlayerDetails from '@/components/players/PlayerDetails'
import PlayerLog from '@/components/players/PlayerLog'
import qs from 'qs'
import Streams from '@/views/Streams'
import Attributes from '@/views/Attributes'
import Blog from '@/views/Blog.vue'
import BlogPost from '@/views/BlogPost.vue'
import Projects from '@/views/Projects.vue'
import Project from '@/views/Project.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/music-library',
      name: 'musicLibrary',
      component: MusicLibrary
    },
    {
      path: '/radios',
      component: Radios,
      name: 'radios'
    },
    {
      path: '/radios/:id',
      component: Radio,
      children: [
        {
          path: '',
          alias: 'schedule',
          name: 'radio',
          component: RadioSchedule
        },
        {
          path: 'players',
          name: 'radioPlayers',
          component: Players
        },
        {
          path: 'streams',
          name: 'radioStreams',
          component: Players
        }
      ]
    },
    {
      path: '/playlists',
      name: 'playlists',
      component: Playlists
    },
    {
      path: '/playlists/:id',
      name: 'playlist',
      component: Playlist
    },
    {
      path: '/players',
      alias: '/',
      name: 'players',
      component: Players
    },
    {
      path: '/streams',
      name: 'streams',
      component: Streams
    },
    {
      path: '/players/:id',
      component: Player,
      children: [
        {
          path: '',
          alias: 'details',
          name: 'player',
          component: PlayerDetails
        },
        {
          path: 'log',
          name: 'playerLog',
          component: PlayerLog
        }
      ]
    },
    {
      path: '/marketing-campaigns',
      name: 'marketingCampaigns',
      component: MarketingCampaigns
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/settings/attributes',
      name: 'attributes',
      component: Attributes
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/blog/create',
      name: 'new-blog-post',
      component: BlogPost
    },
    {
      path: '/blog/:id',
      name: 'blog-post',
      component: BlogPost
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/projects/create',
      name: 'new-project',
      component: Project
    },
    {
      path: '/projects/:id',
      name: 'project',
      component: Project
    }
  ],
  // set custom query resolver
  parseQuery(query) {
    return qs.parse(query)
  },
  stringifyQuery(query) {
    var result = qs.stringify(query)

    return result ? ('?' + result) : ''
  }
})

const allowedRoutes = [
  'login',
  'logout'
]

router.beforeEach((to, from, next) => {
  if (allowedRoutes.indexOf(to.name) > -1) {
    next()
    return
  }

  next()
})

export default router
